import React, { useEffect, useMemo } from 'react';
import './TournamentChampionCelebration.css';

export interface TournamentChampionCelebrationProps {
  tournamentName: string;
  onDismiss: () => void;
}

const CONFETTI_COLORS = [
  '#ffe082',
  '#f9e79f',
  '#4a9eff',
  '#85c1e9',
  '#82e0aa',
  '#f5b041',
  '#ffffff',
  '#f1948a'
];

const TournamentChampionCelebration: React.FC<TournamentChampionCelebrationProps> = ({
  tournamentName,
  onDismiss
}) => {
  const pieces = useMemo(
    () =>
      Array.from({ length: 72 }, (_, i) => ({
        id: i,
        left: `${(i * 137.5) % 100}%`,
        delay: `${(i % 18) * 0.12}s`,
        duration: `${2.8 + (i % 7) * 0.35}s`,
        color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
        drift: `${((i % 9) - 4) * 12}px`
      })),
    []
  );

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onDismiss();
    };
    window.addEventListener('keydown', onKey);
    const auto = window.setTimeout(onDismiss, 14000);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.clearTimeout(auto);
    };
  }, [onDismiss]);

  return (
    <div className="tcc-overlay" role="dialog" aria-modal="true" aria-labelledby="tcc-title">
      <div className="tcc-confetti-layer" aria-hidden="true">
        {pieces.map((p) => (
          <span
            key={p.id}
            className="tcc-piece"
            style={{
              left: p.left,
              background: p.color,
              animationDelay: p.delay,
              animationDuration: p.duration,
              // Custom property used in transform via inline for slight horizontal drift feel
              marginLeft: p.drift
            }}
          />
        ))}
      </div>

      <div className="tcc-card">
        <div className="tcc-trophy" aria-hidden="true">🏆</div>
        <p className="tcc-eyebrow">Tournament Champion</p>
        <h1 id="tcc-title" className="tcc-title">
          You Win!
        </h1>
        <p className="tcc-subtitle">You conquered the finals</p>
        <p className="tcc-tournament-name">{tournamentName}</p>
        <button type="button" className="tcc-dismiss" onClick={onDismiss}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default TournamentChampionCelebration;
